const translations = {
    cancel: 'Cancel',
    email: 'Email',
    emailInvalid: 'Email is invalid',
    firstName: 'First Name',
    firstNameInvalid: 'First name contains invalid characters',
    firstNameMax: 'First name cannot exceed {{nameMax}} characters',
    lastName: 'Last Name',
    lastNameInvalid: 'Last name contains invalid characters',
    lastNameMax: 'Last name cannot exceed {{nameMax}} characters',
    phone: 'Phone',
    phoneInvalid: 'Phone number is invalid',
    save: 'Save',
    saveError: 'Person of contact could not be saved.',
    saving: 'Saving…',
    title: 'Edit Person of Contact'
};

export default translations;
